import FolderIcon from '../assets/icons/folder.svg?react';
import PdfIcon from '../assets/icons/pdf.svg?react';
import ExcelIcon from '../assets/icons/excel.svg?react';
import { REPORT_TYPES } from './reportTypes';

export const fileTypes = {};

export const SPREADSHEET_FILE_ACCEPT =
  'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv,.xlsx,.xls,.xlsm';

export const PDF_EXTRACTION_FILE_ACCEPT = `${SPREADSHEET_FILE_ACCEPT},application/pdf,.pdf`;

export const SPREADSHEET_DROPZONE_ACCEPT = {
  'text/csv': ['.csv'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm']
};

export const PDF_EXTRACTION_DROPZONE_ACCEPT = {
  ...SPREADSHEET_DROPZONE_ACCEPT,
  'application/pdf': ['.pdf']
};

export const workflowSupportsPdfExtraction = reportType =>
  [REPORT_TYPES.ANNEX_IV, REPORT_TYPES.FORM_PF].includes(reportType);

export const getWorkflowFileAccept = reportType =>
  workflowSupportsPdfExtraction(reportType) ? PDF_EXTRACTION_FILE_ACCEPT : SPREADSHEET_FILE_ACCEPT;

export const getWorkflowDropzoneAccept = reportType =>
  workflowSupportsPdfExtraction(reportType)
    ? PDF_EXTRACTION_DROPZONE_ACCEPT
    : SPREADSHEET_DROPZONE_ACCEPT;

export const fileIcons = {
  folder: FolderIcon,
  excel: ExcelIcon,
  csv: ExcelIcon,
  xlsx: ExcelIcon,
  xls: ExcelIcon,
  word: ExcelIcon,
  pdf: PdfIcon
};
